import { ChangeEvent } from '@faro/realtime-services';
import { RealtimeEntityDataHookFactory } from '../package/realtime-query';
import { useServiceContext } from './ServiceContext';

type StudyScopeParameters = { studyId: string };

export function createStudyEntityHookFactory<
    TEntity,
    TScopeParameters extends StudyScopeParameters = StudyScopeParameters,
>(type: string): RealtimeEntityDataHookFactory<ChangeEvent, TScopeParameters, TEntity> {
    return new RealtimeEntityDataHookFactory({
        scopeName: 'study',
        getScopeId: (params: TScopeParameters) => params.studyId,
        getChangeEventService: () => {
            const { changeEventService } = useServiceContext();
            return changeEventService;
        },
        type,
    });
}
